import { RmaRequest } from 'components/ordering/rma/api/rma-request.js'
import { parseRmaConfigDTO, RmaConfigDTO } from 'components/ordering/rma/api/dtos/rma-config-dto.js'

export class GetRmaConfig extends RmaRequest<RmaConfigDTO, never> {
  path = 'account/rma/config/'

  override parseResponse = (data: unknown) =>
    parseRmaConfigDTO((data as { results: unknown }).results)
}
